import { watch, computed, defineComponent, ref, useContext, useCssModule } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import { LIST_SLIDER_LIMIT, LIST_SLIDER_OPTIONS } from './';
import { getArticleInfo } from '~/utils';
import { useDuck } from '~/services';
export default defineComponent({
    name: 'ListSlider',
    props: {
        buttonText: {
            default: 'Смотреть все',
            type: String,
        },
        buttonUrl: {
            default: '',
            type: String,
        },
        items: {
            default: () => [],
            type: Array,
        },
        slug: {
            default: '',
            type: String,
        },
        title: {
            default: '',
            type: String,
        },
        type: {
            default: 'with-images',
            type: String,
            validator(value) {
                return ['with-images', 'without-images'].includes(value);
            },
        },
    },
    setup(props, { root }) {
        /**
         * Composables.
         */
        const css = useCssModule();
        const context = useContext();
        const duck = useDuck();
        const viewport = context.$viewport;
        /**
         * SLides components
         */
        const slidesComponents = {
            'without-images': () => import('~/components/ListSliderSlide/ListSliderSlide.vue'),
            'with-images': () => import('~/components/CardFranchise/CardFranchise.vue'),
        };
        /**
         * Slider options
         */
        const sliderOptions = computed(() => LIST_SLIDER_OPTIONS[props.type]);
        /**
         * Button to
         */
        const buttonTo = computed(() => {
            const FORBES_REGEXP = /(https?)?:?(\/\/)?(www\.)?forbes.ru/g;
            if (FORBES_REGEXP.test(props.buttonUrl)) {
                return props.buttonUrl.replace(FORBES_REGEXP, '');
            }
            return props.buttonUrl;
        });
        /**
         * Current gap
         */
        const currentGap = computed(() => {
            let { itemGap = '' } = sliderOptions.value || {};
            if (props.type === 'without-images') {
                itemGap = viewport.isLessThan('tablet') ? '8px' : '16px';
            }
            return itemGap;
        });
        const list = ref({});
        const articles = ref(props.items);
        const shouldRender = ref(true);
        /**
         * Fetch list task
         */
        const fetchListTask = useTask(function* () {
            try {
                const { data } = yield duck.pub.getPubListById(props.slug, {
                    'list[limit]': String(LIST_SLIDER_LIMIT),
                });
                if (!data?.articles?.length) {
                    shouldRender.value = false;
                    return;
                }
                list.value = data;
                articles.value = data?.articles?.map(({ data }) => ({
                    ...data,
                    ...getArticleInfo.call(root, data),
                }));
            }
            catch (error) {
                shouldRender.value = false;
                console.error(error);
            }
        });
        function handleIntersect({ observer }) {
            if (props.items.length || !props.slug) {
                return observer?.disconnect();
            }
            fetchListTask
                .perform()
                .catch(() => (shouldRender.value = false))
                .finally(() => observer?.disconnect());
        }
        if (!props.slug) {
            watch(() => props.items, (items) => {
                if (!articles.value.length) {
                    articles.value = items;
                }
            }, { immediate: true });
        }
        return {
            articles,
            buttonTo,
            css,
            currentGap,
            fetchListTask,
            handleIntersect,
            list,
            sliderOptions,
            slidesComponents,
            shouldRender,
        };
    },
});
